'use es6';

import { getPendingImagesId } from './getPendingImagesId';
import { getInlineImagesAttachment } from './getInlineImagesAttachment';
export const getInlineImagePendingIds = message => getPendingImagesId(getInlineImagesAttachment(message));